"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var FieldWrapper_1 = __importDefault(require("../FieldWrapper"));
var rc_slider_1 = __importStar(require("rc-slider"));
var formik_1 = require("formik");
var react_bootstrap_1 = require("react-bootstrap");
require("rc-slider/assets/index.css");
var labelMaxWidth = 120;
var SliderField = function (_a) {
    var question = _a.question, questionNumber = _a.questionNumber, fieldName = _a.fieldName, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var _c = react_1.useState(false), dragging = _c[0], setDragging = _c[1];
    return (react_1.default.createElement(FieldWrapper_1.default, { questionNumber: questionNumber, instructions: question.instructions, fieldName: fieldName }, !question.sliderOptions ?
        react_1.default.createElement("h1", null, "No scale options for slider")
        :
            react_1.default.createElement(formik_1.Field, { name: fieldName }, function (_a) {
                var _b;
                var _c, _d, _e, _f;
                var field = _a.field, form = _a.form;
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Row, { className: "align-items-end mb-2 mx-2" },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                            react_1.default.createElement(react_bootstrap_1.Row, null,
                                react_1.default.createElement("span", { style: { position: 'relative', transform: 'translateX(-50%)', maxWidth: labelMaxWidth }, className: "rc-slider-mark-text", onClick: function () {
                                        form.setFieldValue(fieldName, question.sliderOptions.min);
                                    } }, (_c = question.sliderOptions) === null || _c === void 0 ? void 0 : _c.minLabel))),
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                            react_1.default.createElement(react_bootstrap_1.Row, { className: "justify-content-center" },
                                react_1.default.createElement(react_bootstrap_1.Fade, { in: !dragging },
                                    react_1.default.createElement("h6", { className: "mb-0" }, field.value)))),
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                            react_1.default.createElement(react_bootstrap_1.Row, { className: "justify-content-end" },
                                react_1.default.createElement("span", { style: { position: 'relative', transform: 'translateX(50%)', maxWidth: labelMaxWidth }, className: "rc-slider-mark-text", onClick: function () {
                                        form.setFieldValue(fieldName, question.sliderOptions.max);
                                    } }, (_d = question.sliderOptions) === null || _d === void 0 ? void 0 : _d.maxLabel)))),
                    react_1.default.createElement(react_bootstrap_1.Row, { className: "mx-2", id: question.uniqueID + "-slider" },
                        react_1.default.createElement(rc_slider_1.default, { min: question.sliderOptions.min, max: question.sliderOptions.max, marks: (_b = {},
                                _b[question.sliderOptions.min] = question.sliderOptions.min,
                                _b[question.sliderOptions.max] = question.sliderOptions.max,
                                _b), defaultValue: (_e = question.sliderOptions) === null || _e === void 0 ? void 0 : _e.min, value: parseFloat(field.value), step: (_f = question.sliderOptions) === null || _f === void 0 ? void 0 : _f.step, dots: true, disabled: disabled, onChange: function (value) { return form.setFieldValue(fieldName, value.toString()); }, handle: function (props) { return react_1.default.createElement(RenderHandle, __assign({}, props, { onDragChange: function (dragging) { return setDragging(dragging); } })); } }))));
            })));
};
exports.default = SliderField;
var RenderHandle = react_1.default.forwardRef(function (props, ref) {
    var value = props.value, dragging = props.dragging, index = props.index, onDragChange = props.onDragChange, restProps = __rest(props, ["value", "dragging", "index", "onDragChange"]);
    react_1.useEffect(function () {
        onDragChange === null || onDragChange === void 0 ? void 0 : onDragChange(dragging);
    }, [dragging, onDragChange]);
    return (react_1.default.createElement(rc_slider_1.SliderTooltip, { prefixCls: "rc-slider-tooltip", overlay: "" + value, visible: dragging, placement: "top", key: index },
        react_1.default.createElement(rc_slider_1.Handle, __assign({ value: value, ref: ref }, restProps))));
});
